var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkBanner())?_c('div',{staticClass:"premium_market_top",style:(`background-image : url(${_vm.returnThumbnail()})`)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }